import React from 'react';
import hedefnetLogo from '../../assets/images/logo.png';
import hedefnetMenuLogo from '../../assets/images/menuLogo.png';
import filomingoLogo from '../../assets/images/filomingo.png';
import filomingoMenuLogo from '../../assets/images/filomingo_logo_no_bg.png';
import hedefnetBannerBg from '../../assets/images/red-bg.png';
import hedefnetBannerImage from '../../assets/images/desktop.png';
import filomingoBannerBg from '../../assets/images/filo-bg.png';
import filomingoBannerImage from '../../assets/images/filomingo_transparent.png';

export type PlatformType = 'HEDEFNET' | 'FILOMINGO';

export interface PlatformConfig {
  type: PlatformType;
  primaryColor: string;
  primaryColorLight: string;
  primaryColorBorder: string;
  chartColors: string[];
  loginLogo: string;
  loginLogoClassName: string;
  loginLogoStyle: React.CSSProperties;
  menuLogo: string;
  contentKeyPrefix: string;
  bannerBg: string;
  bannerImage: string;
  appTitle: string;
}

const PLATFORM = (
  (process.env.REACT_APP_PLATFORM ?? 'HEDEFNET').toUpperCase()
) as PlatformType;

const configs: Record<PlatformType, PlatformConfig> = {
  HEDEFNET: {
    type: 'HEDEFNET',
    primaryColor: '#E92127',
    primaryColorLight: '#FFEDEE',
    primaryColorBorder: '#F0A0A3',
    chartColors: ['#E92127', '#57717F', '#8ABDC2', '#F0A0A3'],
    loginLogo: hedefnetLogo,
    loginLogoClassName: '',
    loginLogoStyle: {
      width: '14rem',
      height: '2rem',
      marginBottom: '3.5rem',
      marginTop: '3.5rem',
    },
    menuLogo: hedefnetMenuLogo,
    contentKeyPrefix: 'hedefnet',
    bannerBg: hedefnetBannerBg,
    bannerImage: hedefnetBannerImage,
    appTitle: 'Hedefnet',
  },
  FILOMINGO: {
    type: 'FILOMINGO',
    primaryColor: '#f05757',
    primaryColorLight: '#FFECEC',
    primaryColorBorder: '#F0A0A3',
    chartColors: ['#f05757', '#57717F', '#8ABDC2', '#F0A0A3'],
    loginLogo: filomingoLogo,
    loginLogoClassName: '',
    loginLogoStyle: { width: '20rem', marginBottom: '2.5rem' },
    menuLogo: filomingoMenuLogo,
    contentKeyPrefix: 'hedefnet',
    bannerBg: filomingoBannerBg,
    bannerImage: filomingoBannerImage,
    appTitle: 'Filomingo',
  },
};

export const platformConfig: PlatformConfig = configs[PLATFORM] ?? configs.HEDEFNET;

export const platformKey = (suffix: string): string =>
  `${platformConfig.contentKeyPrefix}.${suffix}`;
